<template>
  <v-container fluid>
    <v-row>
        <v-col>
          <h1 class="headline mb-1">Bandeja de entrada</h1>
          <DataTableServerSide opt="inbox">
          </DataTableServerSide>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTableServerSide from '@/components/DataTableServerSide.vue'; 
export default {
  components: { DataTableServerSide },
  data: function() {
    return {
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {

  },
  mounted() {

  },
  methods: {

  },
};
</script>